import React, {useCallback, useMemo} from "react";
import * as fieldComponents from "../Models/Core/FieldComponents";

function CombinedFieldComponent(props) {

    const {
        componentDefinitions,
        fieldDefPrefix = '',
        FieldDefinitionGroups: fieldGroupDefinitions,
    } = props;

    const fieldComponentRenderer = useFieldComponentRenderer(props);

    const components = componentDefinitions.map((componentDefinition, i) => {

        const {
            component: componentName = "TextFieldViewer",
            fieldKey = null,
            value = null
        } = componentDefinition;

        const fieldDefinition = fieldGroupDefinitions.find(group => (
            group.value.find(field => (
                field.key === (fieldDefPrefix + fieldKey)
            ))
        ));

        return fieldComponentRenderer(componentName, fieldDefinition, value, fieldKey ?? String(i));
    });

    return <div className="sb-combined-field-viewer">{components}</div>;
}

export const useFieldComponentRenderer = (props) => {

    const {
        FieldDef,
        FieldDefinitionGroups = null,
        SkipBorder,
        Validation = {},
        RootData,
        Data,
        OnValidationUpdate,
        CustomData,
        IsNewModel,
        DefaultSelectedFieldDefKey,
        // tdClassName = '',
        // TODO: below seems to override null
        // values from the model, should we
        // change that behavior?
        defaultValue = undefined,
        // subText = null,
        UpdateField: updateField,
        UpdateFields: updateFields,
    } = props;

    return (componentName = "TextFieldViewer", fieldDefinition = FieldDef, value = null, key = null, fieldDefs = null) => {

        if(componentName instanceof Array) {
            return <CombinedFieldComponent
                {...props}
                fieldDefPrefix={fieldDefinition?.keyPrefix}
                componentDefinitions={componentName}
            />;
        }

        const FieldComponent = fieldComponents?.[componentName] ?? null;

        if(FieldComponent == null) {
            console.log('FieldComponent with name: `' + componentName + '` was not defined.')
            return null;
        }
        
        const onUpdate = useCallback((y, field = fieldDefinition) => {
            return updateField?.(field ?? fieldDefinition, y);
        },[fieldDefinition, updateField]);
        
        const onUpdates = useCallback((y) => {
            return updateFields?.(y);
        }, [updateFields]);
        
        return <FieldComponent
            key={key ?? fieldDefinition.key}
            Value={fieldDefinition?.getter?.(Data) ?? value ?? defaultValue}
            OnUpdate={onUpdate}
            OnUpdates={onUpdates}
            FieldDef={fieldDefinition}
            RootData={RootData}
            Data={Data}
            FieldDefs={FieldDefinitionGroups ?? fieldDefs}
            SkipBorder={SkipBorder}
            OnValidationUpdate={OnValidationUpdate}
            Validation={Validation}
            CustomData={CustomData}
            IsNewModel={IsNewModel}
            DefaultSelectedFieldDefKey={DefaultSelectedFieldDefKey}
        />
    }
}

export const useNormalizedFieldComponentName = (fieldComponentName) => {
    const viewersStringPrefix = "viewers."
    return useMemo(() => {
            // some field components (especially in historical Activity `data`)
            // have a component name prefixed with "viewers."
            // to handle those legacy cases, this code normalizes the componentName
            if (!fieldComponentName) {
                return fieldComponentName;
            }
            if (fieldComponentName.startsWith(viewersStringPrefix)) {
                return fieldComponentName.substring(viewersStringPrefix.length);
            }
            return fieldComponentName;
        },
        [fieldComponentName]
    );
}
